import {
  Card,
  CardContent,
  Container,
  Divider,
  Typography,
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import { useSelector } from "react-redux";

const useStyles = makeStyles((theme) => ({
  root: {
    display: "flex",
    flex: 1,
    height: "100%",
    padding: 10,
    justifyContent: "center",
    alignItems: "center",
    backgroundImage: `url(./assets/images/bg-login.png), linear-gradient(to bottom left, ${theme.palette.primary.main}, #00c2cb 45%, ${theme.palette.secondary.main})`,
    objectFit: "cover",
    backgroundSize: "cover",
    backgroundPosition: "50% 50%",
    backgroundRepeat: "no-repeat",
    backgroundBlendMode: "screen",
  },
  paper: {
    display: "flex",
    flexDirection: "column",
    boxShadow: "0 3px 17px 0 rgba(44, 40, 40, 0.11)",

    paddingLeft: 25,
    paddingRight: 25,
    paddingTop: 25,
    paddingButton: 45,
    flex: 1,
    borderRadius: 10,
  },
  content: {
    display: "flex",
    flexDirection: "column",
    flex: 1,
  },
  logo: {
    display: "flex",
    alignSelf: "center",
    width: 300,
    margin: theme.spacing(4),
  },
  title: {
    fontSize: 55,
    color: "#003b5c",
  },
  submit: {
    margin: theme.spacing(3, 0, 2),
    height: 50,
    backgroundColor: "#11cdef",
    alignSelf: "center",
  },
  offlineLogin: {
    alignSelf: "center",
  },
  loading: {
    marginRight: theme.spacing(1),
  },
  line: {
    marginTop: 8,
    height: 3,
    width: 50,
    backgroundColor: "#11cdef",
  },
}));

export default function CookiePrivacyPage() {
  const classes = useStyles();

  const { isLoading, isSuccess, isFailure } = useSelector(
    (state) => state.auth
  );

  return (
    <>
      <div className={classes.root}>
        <Container style={{ marginBottom: 20 }}>
          <Card className={classes.paper}>
            <CardContent className={classes.content}>
              <Typography variant="h4" className={classes.title}>
                Cookie-Policy
              </Typography>
              <Typography variant="h6">BOI VISA Service</Typography>
              <div className={classes.line} />
              <img
                alt="smart-visa"
                src="/assets/images/logoBoi.png"
                className={classes.logo}
              />
              {/* <center>
                <Typography variant="h3" style={{ color: "#009999" }}>
                  Cookie-Policy
                </Typography>
              </center> */}
              <br />
              <Typography
                variant="h6"
                style={{ color: "#555555", fontWeight: "bold" }}
              >
                “Cookies” means Cookies and similar technologies that is under
                the requirements of the Privacy Protection in electronic
                communications.
              </Typography>
              <Divider style={{ margin: 10 }} />
              <Typography
                variant="h6"
                style={{ color: "#555555", fontWeight: "bold" }}
              >
                What Are Cookies?
              </Typography>
              <Typography
                variant="body1"
                style={{ color: "#555555", marginLeft: 10 }}
              >
                <p>
                  Cookie is a small file placed onto your computer or your
                  devices when you visit our website.{" "}
                </p>
                <p>
                  Some cookies are deleted automatically when you leave the
                  website, but some cookies are saved on your browser for the
                  prescribed period (Depend on the lifetime of the specific
                  cookie).{" "}
                </p>
                <p>
                  Every time you visit our website, remain cookies on your
                  computer or devices will allow us to recognize your browser as
                  an existing user. Moreover, you have the ability to accept or
                  decline cookies by modifying the settings in your browser.
                </p>
              </Typography>

              <Typography
                variant="h6"
                style={{ color: "#555555", fontWeight: "bold", marginTop: 10 }}
              >
                Why using Cookies
              </Typography>
              <Typography
                variant="body1"
                style={{ color: "#555555", marginLeft: 10 }}
              >
                <p>
                  Cookies play an important role. We use cookies for remembering
                  your safe search preferences, analyzing trends, and tracking
                  users’ movements around the sites. This helps us provide you
                  with a better experience by improving the content and making
                  our sites easier to use.
                </p>
              </Typography>

              <Typography
                variant="h6"
                style={{ color: "#555555", fontWeight: "bold", marginTop: 10 }}
              >
                Third-Party Cookies
              </Typography>
              <Typography
                variant="body1"
                style={{ color: "#555555", marginLeft: 10 }}
              >
                <p>
                  Some of our pages display content from external providers,
                  e.g. YouTube, Facebook and Twitter.
                </p>
                <p>
                  Please note that we have no control using cookies of third
                  parties. To view this third-party content, you first have to
                  accept their specific terms and conditions.
                </p>
                <p style={{ textDecoration: "underline" }}>
                  Rejection and Subtraction
                </p>
                <p>
                  For Privacy Data Protection, you can accept or decline cookies
                  by modifying the settings in your browser.
                  <font style={{ textDecoration: "underline" }}>
                    When you are blocking cookies, be aware though that you have
                    to manually adjust some preferences every time you visit our
                    website.
                  </font>
                </p>
                <p style={{ textDecoration: "underline" }}>
                  If you disable cookies, you are still able to visit our
                  website. However, some operations on the website may not be
                  available and complete.
                </p>
              </Typography>
              <Typography
                variant="h6"
                style={{ color: "#555555", fontWeight: "bold", marginTop: 10 }}
              >
                Contact us
              </Typography>
              <Typography
                variant="body1"
                style={{ color: "#555555", marginLeft: 10 }}
              >
                <p>
                  If you have any question or suggestion of this policy, please
                  contact us by email :{" "}
                  <a style={{ color: "#627491" }} href="mailto:ltr@boi.go.th">
                    ltr@boi.go.th
                  </a>
                </p>
              </Typography>
            </CardContent>
          </Card>
        </Container>
      </div>
    </>
  );
}
